import { useState, useEffect } from 'react';
import axios from 'axios';

import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import PlanetLinks from '../../../components/PlanetLinks/PlanetLinks';

import './Solar.scss';

const Solar = () => {
  const [year, setYear] = useState(2025);
  const [solarEclipses, setSolarEclipses] = useState([]);

  // Fetch solar eclipses for given year
  useEffect(() => {
    axios
      .get(`https://core-c343.onrender.com/api/eclipes?year=${year}`)
      .then((res) => {
        const solarOnly = res.data.months.filter((e) =>
          e.eclipseType.toLowerCase().includes("solar")
        );
        setSolarEclipses(solarOnly);
      })
      .catch((err) => {
        console.error("Error fetching eclipse data:", err);
      });
  }, [year]);

  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  return (
    <div className="Solar-container">
      <InnerNav />
      <div className="Solar-content">
        <Zodiac />

        <div className="Solar-details">
          <div className="title">{year} Solar Eclipse Dates</div>

          {/* Year controls */}
          <div className="solar-controls">
            <input
              type="number"
              value={year}
              onChange={handleYearInput}
            />
            <button onClick={() => changeYear(-1)}>Prev Year</button>
            <button onClick={() => setYear(new Date().getFullYear())}>
              Current Year
            </button>
            <button onClick={() => changeYear(1)}>Next Year</button>
          </div>

          {/* Eclipse list */}
          <div className="muhurta-section">
            {solarEclipses.length === 0 ? (
              <p>No Solar Eclipse data available for this year.</p>
            ) : (
              solarEclipses.map((entry, index) => (
                <div className="rahu-card" key={index}>
                  <div className="rahu-header">
                    <h3>{entry.description}</h3>
                    <p>
                      {entry.date} ({entry.weekday})
                    </p>
                  </div>
                  <div className="rahu-img">
                    <img
                    src='https://images.unsplash.com/photo-1529788295308-1eace6f67388?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE0fHx8ZW58MHx8fHx8'
                      alt="solar"
                    />
                  </div>
                  <div className="rahu-data">
                    <h4>{entry.astronomicalEvent}</h4>
                    <p>{entry.visibilityNote}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <PlanetLinks />
      </div>
      <Footer />
    </div>
  );
};

export default Solar;
